module.exports = __webpack_public_path__ + "img/call-circle-red-transparent.21dcdee.svg";